import { z } from "zod"

export const email = z
  .string()
  .email()
  .transform((str) => str.toLowerCase().trim())

export const password = z
  .string()
  .min(10)
  .max(100)
  .transform((str) => str.trim())

export const organisation = z.string().transform((str) => str.trim())

export const Signup = z.object({
  email,
  password,
  organisation,
})

export const Login = z.object({
  email,
  password: z.string(),
})
export const LoginInput = Login.extend({
  useCode: z.boolean().optional(),
})

// export const LoginWithCode = z.object({
//   loginCode: z
//     .string()
//     .min(7)
//     .max(7)
//     .transform((str) => str.trim()),
// })
//
// export const LoginPWOrCode = z.union([Login, LoginWithCode])

export const ForgotPassword = z.object({
  email,
})

export const ResetPassword = z
  .object({
    password: password,
    passwordConfirmation: password,
    token: z.string(),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    message: "Passwords don't match",
    path: ["passwordConfirmation"], // set the path of the error
  })

export const ChangePassword = z.object({
  currentPassword: z.string(),
  newPassword: password,
})
